import apiClient from "./apiClient";
import {
  CallViewsDashboardResponse,
  CallViewsQueryParams,
  CallViewsExportParams,
} from "../types/call-views.types";

/**
 * Fetch Call Views Dashboard data
 * Endpoint: GET /grants/admin/call-views?startDate&endDate
 */
export const getCallViewsDashboard = async (
  params?: CallViewsQueryParams
): Promise<CallViewsDashboardResponse> => {
  const searchParams = new URLSearchParams();
  if (params?.startDate) searchParams.append("startDate", params.startDate);
  if (params?.endDate) searchParams.append("endDate", params.endDate);

  const queryString = searchParams.toString();
  const url = `/grants/admin/call-views${queryString ? `?${queryString}` : ""}`;

  const { data } = await apiClient.get<CallViewsDashboardResponse>(url);
  return data;
};

/**
 * Export Call Views data as CSV (streaming).
 * Endpoint: GET /grants/admin/call-views/export
 */
export const exportCallViewsCsv = async (
  params: CallViewsExportParams
): Promise<Blob> => {
  const searchParams = new URLSearchParams();
  searchParams.append("startDate", params.startDate);
  searchParams.append("endDate", params.endDate);

  const { data } = await apiClient.get(
    `/grants/admin/call-views/export?${searchParams.toString()}`,
    {
      responseType: "blob",
    }
  );

  return data;
};

/**
 * Download helper - triggers browser download
 */
export const downloadCsvBlob = (blob: Blob, filename: string): void => {
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.setAttribute("download", filename);
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.URL.revokeObjectURL(url);
};

/**
 * Generate CSV filename based on date range
 */
export const generateCsvFilename = (startDate: string, endDate: string): string => {
  const start = startDate.split("T")[0];
  const end = endDate.split("T")[0];
  return `przegladanie-naborow-${start}-${end}.csv`;
};
